<template>
  <div class="overflow-auto w-full p-10px">
    <div v-for="item in flatLayerObjects" :key="item" @click="setSelectObject(item)"
      class="w-full h-[50px] flex items-center bg-[#F8FAFC] rounded-[10px] px-10px mb-10px cursor-pointer hover:bg-[#e6f7ff] hover:hover:border-[#b3e5fc] relative"
      :class="{ 'bg-[#1f92f0] text-[#1f92f0] font-bold  shadow-[0_2px_8px_#1769aa44]': item.id == selectedElement.id }">
      <span>
        {{ item.id || item.name || item.type || '未命名元素' }} {{ item.type }}
      </span>
      <div class="ml-auto flex gap-8px" v-if="haveTag(item.id) && item.id == selectedElement.id">
        <div
          class="px-12px h-30px flex align-center rounded-[6px] border border-[#E5E7EB] bg-white text-[#4B5563] hover:bg-[#F9FAFB]  cursor-pointer"
          @click.stop="opentagdialog(item)">编辑</div>
        <div class="px-12px h-30px flex align-center rounded-[6px] bg-[#F87171]  hover:bg-[#EF4444] cursor-pointer"
          @click.stop="onDelete(item)" style="color: #fff">删除</div>
      </div>
      <div v-if="haveTag(item.id)" class="absolute right-0 top-0 triangle w-[10px] h-[10px] bg-[#2A66FF]"></div>

    </div>
  </div>

</template>

<script lang="ts" setup>
import { ref, onMounted, computed, watch } from 'vue'
import { ElMessageBox } from 'element-plus'
import axios from 'axios'
import { resourceTokenGenerate } from '@/api/design/resource'

import { storeToRefs } from 'pinia'
import { useTagListStore } from "@/stores/tag";
const tagListStore = useTagListStore()
import { opentagdialog } from '@/common/design'
import { useSdkStore } from "@/stores/sdk";
const sdkStore = useSdkStore();
const WorkSpaceDrawType = 'WorkSpaceDrawType'
const WorkSpaceClipType = 'WorkSpaceClipType'
const WorkSpaceSafeType = 'WorkSpaceSafeType'
const WorkSpaceMaskType = 'WorkSpaceMaskType'
const WorkSpaceLineType = 'WorkSpaceLineType'
const WorkSpaceShadowType = 'WorkSpaceShadowType'
const WorkSpaceCommonType = [WorkSpaceClipType, WorkSpaceSafeType, WorkSpaceMaskType, WorkSpaceLineType, WorkSpaceShadowType, WorkSpaceDrawType]
const ElementNames = {
  TEXTBOX: 'textbox',
  TEXT: 'text',
  ITEXT: 'i-text',
  INPUTTEXT: 'itext',
  ARCTEXT: 'arctext',
  VERTICALTEXT: 'verticaltext',
  IMAGE: 'image',
  SVGIMAGE: 'svgimage',
  CROPIMAGE: 'cropimage',
  MASK: 'mask',
  PATH: 'path',
  RECT: 'rect',
  FABRICRECT: 'fabricrect',
  RECTTEXT: 'recttext',
  LINE: 'line',
  ARROW: 'arrow',
  POLYLINE: 'polyline',
  ELLIPSE: 'ellipse',
  QRCODE: 'qrcode',
  BARCODE: 'barcode',
  GROUP: 'group',
  ACTIVE: 'activeselection',
  CIRCLE: 'circle',
  TABLE: 'table',
  REFERENCELINE: 'referenceline',
  DOT: 'dot'
}


const layerObjects = computed(() => {
  let currentTemplate = sdkStore.getSdk().designOpt.getTemplate().currentTemplate.value
  return currentTemplate.objects.filter(
    (item) =>
      !WorkSpaceCommonType.includes(item.id) &&
      item.type.toLowerCase() !== ElementNames.REFERENCELINE &&
      item.type.toLowerCase()
  )
    .reverse();
})

// const selectedElement = ref({})
const selectedElement = computed(() => {
  let currentTemplate = sdkStore.getSdk().designOpt.getSelectedElement().activeObject
  return currentTemplate || {}
})

const setSelectObject = (item: any) => {
  sdkStore.getSdk().designOpt.setSelectObject(item.id)
}
const currentTemplate = computed(() => {
  return sdkStore.getSdk().designOpt.getTemplate().currentTemplate.value
})
const flatLayerObjects = computed(() => flattenObjects(layerObjects.value));
function flattenObjects(objects: any[]): any[] {
  const result: any[] = [];
  objects.forEach(obj => {
    if (obj.type === 'Group' && Array.isArray(obj.objects)) {
      result.push(...flattenObjects(obj.objects));
    } else {
      const typeStr = String(obj.type).toLowerCase();
      if (typeStr === 'image' || typeStr.includes('text')) {
        result.push(obj);
      }
    }
  });
  return result;
}
const haveTag = (id: string) => {
  let tagDetail = tagListStore.getTagDetail(currentTemplate.value.id, id)
  return tagDetail ? true : false
}

const onEdit = (item: any) => {
  console.log('edit tag', item)
}
const onDelete = (item: any) => {
  ElMessageBox.confirm(
    '确定要删除该标记吗？此操作不可撤销。',
    '删除确认',
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }
  ).then(async () => {

    tagListStore.removeTag(currentTemplate.value.id, item.id)
    const urlParams = new URLSearchParams(window.location.search)
    const pk = urlParams.get('id') as string
    const res = await resourceTokenGenerate({ pk, ext: 'tags', filename: 'tagJson' });
    if (res.data.code == 200) {
      const token = res.data.data.token
      await axios.put(token, tagListStore.allTagGroups)
    }
  }).catch(() => {
    // 用户取消，无需处理
  })
}


// watch(selectedObject, (newValue, oldValue) => {
//   if (newValue) {
//     selectedElement.value = newValue
//   } else {
//     selectedElement.value = {}
//   }
// }, { deep: true })

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.triangle {
  clip-path: polygon(100% 0, 100% 100%, 0 0);
}
</style>
